import { GoogleAnalytics } from "~/google_analytics/events";
import { EventParameter } from "~/google_analytics/events.enum";

export type BasicUser = {
  first_name?: string | null;
  phone?: string | number | null;
};

type ToastVariant = 'first_time' | 'repeat' | 'fallback';

type ToastAnalyticsOverrides = Partial<{
  toast_variant: ToastVariant;
  page_name: string;
  page_type: string;
}>;

function capitalizeFirst(s: string) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

function buildWelcomeMessage(user: BasicUser | undefined, isNewUser: boolean): string {
  const runtimeConfig = useRuntimeConfig()
  const partnerName = usePartnerDisplayName(runtimeConfig.public.partnerCode);
  let message = 'Hi There!';
  const raw = user?.first_name;
  if (raw && typeof raw === 'string' && raw.trim()) {
    const clean = capitalizeFirst(raw.trim());
    const displayName = clean.length > 33 ? clean.slice(0, 33) + '..' : clean;
    message = isNewUser
      ? `Hi ${displayName}! Welcome to ${partnerName}.`
      : `Hi ${displayName}! You are now logged in to ${partnerName}.`;
  }
  return message;
}

export function useLoginBanner() {
  const loginBannerMessage = useState<string | null>('loginBannerMessage', () => null);

  function showLoginBanner(msg: string, durationMs = 10000) {
    loginBannerMessage.value = msg;
    window.setTimeout(() => { loginBannerMessage.value = null; }, durationMs);
  }


  function showWelcomeBanner(
    user: BasicUser | undefined,
    isNewUser: boolean,
    durationMs = 3000,
    overrides?: ToastAnalyticsOverrides
  ) {
    const msg = buildWelcomeMessage(user, isNewUser);
    showLoginBanner(msg, durationMs); 
    GoogleAnalytics.toast({
      [EventParameter.TOAST_MESSAGE]: msg,
    });
  }

  return { loginBannerMessage, showLoginBanner, showWelcomeBanner };
}
